import React from 'react'
import summarizeGif from "../../assets/icons/summarize.gif";

const SummaryLoader = () => {
  return (
    <section className="bg-customBlack rounded-md gap-3 flex flex-col justify-center w-full h-full items-center">
        <img
          className="w-56 h-56"
          fetchPriority="high"
          src={summarizeGif}
          alt="summariser"
        />
        <div className="flex flex-col text-center items-center justify-center">
          <h3 className="text-3xl font-semibold text-white">
            Generating Document Summary
          </h3>
          <p className="text-sm font-light">
            Please be patient while we Generate Your Document Summary
          </p>
        </div>
        <p className="text-sm font-light text-center">
          This Document summary is Generated by{" "}
          <span className="text-teal-400 font-semibold">Adira AI.</span>
          <br /> Download your Document summary and Use it for your reference.
        </p>
      </section>
  )
}

export default SummaryLoader